import { Routes } from '../api-routes'
import { UserDTO } from '../dtos/user'

export namespace AuthPublicRoutes {
  export namespace requestPasswordReset {
    export function call() {
      return `/${Routes.Public}/password-reset/request`
    }

    export type Request = { email: string }
    export type Response = void
  }

  export namespace resetPassword {
    export function call() {
      return `/${Routes.Public}/password-reset/reset`
    }

    export type Request = { token: string; newPassword: string }
    export type Response = void
  }

  export namespace verify {
    export function call() {
      return '/auth/verify'
    }

    export type Request = { accessToken: string }
    export type Response = { userId: string }
  }
}

export namespace AuthRoutes {
  export namespace getCurrent {
    export function call() {
      return `/${Routes.Users}/getCurrent`
    }

    export type Response = { user: UserDTO }
  }

  export namespace patchCurrent {
    export function call() {
      return `/${Routes.Users}/patchCurrent`
    }

    export type Request = {
      fields: Partial<
        Pick<UserDTO, 'firstName' | 'lastName' | 'email' | 'language'>
      >
    }
    export type Response = { user: UserDTO }
  }

  export namespace patchPassword {
    export function call() {
      return `/${Routes.CaseWorkers}/password`
    }

    export type Request = { password: string }
    export type Response = boolean
  }
}
